import { BehaviorSubject, catchError, of, tap, throwError } from 'rxjs';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
  HttpParamsOptions,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { EncryptionService } from './Encryption.service';
import { AppConfigService } from './app-config.service';
import { Router } from '@angular/router';
@Injectable({
  providedIn: 'root',
})
export class LoginService {
  loginStatus: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  loginStatus$ = this.loginStatus.asObservable();
  constructor(
    private http: HttpClient,
    private encryption: EncryptionService,
    private router: Router
  ) {}

  Login(username: string, password: string): any {
    var authModel = {
      UserName: username,
      Password: this.encryption.encryptUsingTripleDES(password, false),
    };
    const link = `${AppConfigService.settings.apiUrl}Authentication/Login`;
    return this.http.post(link, authModel);
  }

  refreshToken() {
    const token = localStorage.getItem('token');
    const refreshToken = localStorage.getItem('refreshToken');
    if (token == null || refreshToken == null) {
      this.loginStatus.next(false);
      this.router.navigate(['/auth/login']);
      throw new Error('No stored refresh token ');
    }
    let appendedHeaders = new HttpHeaders({
      refreshToken: refreshToken ?? '',
    });

    return this.http.get(
      `${AppConfigService.settings.apiUrl}Authentication/Refresh-Token`,
      {
        headers: appendedHeaders,
      }
    );
  }

  sendResetPassRequest(email: string) {
    return this.http.get(
      `${AppConfigService.settings.apiUrl}Authentication/reset-password-request?userEmail=${email}`
    );
  }

  resetPassword(token: string, email: string, newPassword: string) {
    const encodedPass = this.encryption.encryptUsingTripleDES(
      newPassword,
      false
    );
    const handledToken = token.replace(/ /g, '+');
    return this.http.post(
      `${AppConfigService.settings.apiUrl}Authentication/reset-password`,
      {
        RecoveryToken: handledToken,
        Email: email,
        Password: encodedPass,
      }
    );
  }
  logout() {
    return this.http.get(
      `${AppConfigService.settings.apiUrl}Authentication/logout`
    );
  }
  clearTokens() {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
  
    this.router.navigate(['/']);
  }

  validRole(role: string, roleName: string): boolean {
    if (roleName == null) {
      return true;
    }
    const roles = roleName.split(',');
    if (
      role == null ||
      (role != null && !roles.includes(role)) /*role != this.roleName*/
    ) {
      return false;
    }
    return true;
  }
}
